import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useRemoveWorkflowPermissionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { usePermissionsContext } from '../../../../PermissionsContext'
import { WorkflowPermissionRecord } from '../../../../types'

export function useRemove(): RemoveRowActionOptions<WorkflowPermissionRecord> {
  const { refetch } = usePermissionsContext()
  const [removePermission] = useRemoveWorkflowPermissionMutation(
    DefaultMutationHookOptions
  )

  return {
    permission: 'admin',
    onRemove: async ({ id }) => {
      await removePermission({ variables: { input: { id } } })
      await refetch()
      simpleRemoveNotification('Permission')
    },
  }
}
